import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { AdminRoute } from '@/components/routing/AdminRoute'
import { suspensePage } from '@/routes/suspensePage'

const AdminDashboardPage = lazy(() => import('@/pages/admin/AdminDashboardPage'))
const AdminFeaturesPage = lazy(() => import('@/pages/admin/AdminFeaturesPage'))
const AdminJobsPage = lazy(() => import('@/pages/admin/AdminJobsPage'))
const AdminLogsPage = lazy(() => import('@/pages/admin/AdminLogsPage'))
const AdminSessionsPage = lazy(() => import('@/pages/admin/AdminSessionsPage'))

/** Admin-only routes (`user.admin === true`). */
export const adminRoutes: RouteObject = {
  path: 'admin',
  element: <AdminRoute />,
  children: [
    { index: true, element: suspensePage(AdminDashboardPage) },
    { path: 'jobs', element: suspensePage(AdminJobsPage) },
    { path: 'logs', element: suspensePage(AdminLogsPage) },
    { path: 'sessions', element: suspensePage(AdminSessionsPage) },
    { path: 'features', element: suspensePage(AdminFeaturesPage) },
  ],
}
